import ReactDOM from 'react-dom';

import { BackInStockNotificationApp } from './containers/BackInStockNotificationApp';
import { getConfiguration } from './helpers/getConfiguration';
import { translationsProvider } from './providers';

export const render = async (rootElement: HTMLElement): Promise<void> => {
    const {
        currentLanguage,
        translations: translationsFromDataset,
        onlineBaseUrl,
        ...otherConfig
    } = getConfiguration(rootElement);

    const translations =
        translationsFromDataset ??
        (await translationsProvider(onlineBaseUrl ?? window.location.origin, currentLanguage));

    ReactDOM.render(
        <BackInStockNotificationApp
            currentLanguage={currentLanguage}
            onlineBaseUrl={onlineBaseUrl}
            translations={translations}
            {...otherConfig}
        />,
        rootElement,
    );
};
